export var PermissionResource = {
    SETTINGS: "CLIENT/SETTINGS",
    ASSESSMENTS: "CLIENT/ASSESSMENTS",
    ASSESSMENTS_LEADERS: "CLIENT/ASSESSMENTS/LEADERS",
    ASSESSMENTS_PROJECTS: "CLIENT/ASSESSMENTS/PROJECTS",
    SUCCESS_PROFILES: "CLIENT/SUCCESSPROFILES",
    SUCCESS_PROFILES_FACTOR_LIBRARY: "CLIENT/SUCCESSPROFILES/FACTORLIBRARY",
    SUCCESS_PROFILES_SUCCESS_PROFILE_LIBRARY: "CLIENT/SUCCESSPROFILES/SUCCESSPROFILELIBRARY",
    SUCCESS_PROFILES_VARIABLE_LIBRARY: "CLIENT/SUCCESSPROFILES/VARIABLELIBRARY",
    COHORT_INSIGHTS: "ORG_DASHBOARD_UI/COHORT_INSIGHTS",
};
export var permissionKeys = {
    diversitySetting: "ORG_DASHBOARD_UI/DIVERSITY/SETTINGS",
    diversity: "ORG_DASHBOARD_UI/DIVERSITY",
    succession: "ORG_DASHBOARD_UI/SUCCESSION",
    mobility: "ORG_DASHBOARD_UI/MOBILITY",
    cohortInsights: "ORG_DASHBOARD_UI/COHORT_INSIGHTS",
};
